import React from 'react';

import Tag from './Tag';

const UserTag = props => {
  return <Tag rootClassName={'user-tag'} {...props} />;
};

export default UserTag;
